import { useCallback, useRef, useState } from "react";
import type { SessionReadOwnMessageIds } from "./use-session-read-tracking.types";

export function useSessionReadOwnMessageIds(): SessionReadOwnMessageIds {
  const [ownMessageIds, setOwnMessageIds] = useState<ReadonlySet<string>>(
    () => new Set<string>(),
  );
  const ownMessageIdsRef = useRef<Set<string>>(new Set());

  const addOwnMessageIds = useCallback((messageIds: string[]): void => {
    if (messageIds.length === 0) return;

    const nextOwnMessageIds = new Set(ownMessageIdsRef.current);
    let didChange = false;
    messageIds.forEach((messageId) => {
      if (nextOwnMessageIds.has(messageId)) return;
      nextOwnMessageIds.add(messageId);
      didChange = true;
    });

    if (!didChange) return;
    ownMessageIdsRef.current = nextOwnMessageIds;
    setOwnMessageIds(nextOwnMessageIds);
  }, []);

  const resetOwnMessageIds = useCallback((): void => {
    const emptyOwnMessageIds = new Set<string>();
    ownMessageIdsRef.current = emptyOwnMessageIds;
    setOwnMessageIds(emptyOwnMessageIds);
  }, []);

  return {
    ownMessageIds,
    ownMessageIdsRef,
    addOwnMessageIds,
    resetOwnMessageIds,
  };
}
